<template>

  <div class="py-4 container-fluid">
    <div class="row">

      <div class="col-md-8">
        <div class="card mb-2">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">Crear Producto</p>
              <argon-button color="success" size="sm" class="ms-auto" @click="save" :disabled="isSaving">Guardar</argon-button>
            </div>
          </div>
          <div class="card-body">
            <p class="text-uppercase text-sm">Información</p>
            <div class="row">
              <div class="col-md-8">
                <label for="example-text-input" class="form-control-label">Nombre</label>
                <argon-input type="text" v-model="form.name" />
              </div>

              <div class="col-md-4">
                <label for="example-text-input" class="form-control-label">Referencia</label>
                <argon-input type="text" v-model="form.ref" />
              </div>

              <div class="col-md-12">
                <label for="example-text-input" class="form-control-label">Descripción</label>
                <argon-textarea type="text" v-model="form.description" />
              </div>

              <div class="col-md-6">
                <label class="form-control-label">Categoría</label>
                <select ref="categorySelect" class="form-control">
                  <option value=""></option>
                  <option v-for="cat in categoriesList" :key="cat.id" :value="cat.id">{{ cat.name }}</option>
                </select>
              </div>

              <div class="col-md-6"></div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Código de barras</label>
                <div class="input-group">
                  <input type="text" class="form-control" v-model="form.barcode" />
                  
                  <button
                    type="button"
                    class="btn btn-outline-secondary mb-0"
                    title="Imprimir código de barras"
                    @click="openPrintModal(form.barcode, form.name, form.sale_price)"
                    style="border-right: 1px solid #000000 !important;"

                  >
                    <i class="fas fa-barcode"></i>
                  </button>
                </div>
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Stock</label>
                <argon-input type="text" v-model="form.quantity" />
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Precio de compra</label>
                <argon-input type="text" v-model="form.price" />
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Precio de venta</label>
                <argon-input type="text" v-model="form.sale_price" />
              </div>

              

              <div class="col-md-12 d-flex align-items-center mt-4 mb-4">
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="manageStock"
                    v-model="form.manage_stock"
                  />
                  <label class="form-check-label ms-2" for="manageStock">
                    Permitir sobrepedido
                  </label>
                </div>
              </div>

              <br>
              <hr>

              <div class="col-md-4">
                <label for="example-text-input" class="form-control-label">Cant mininima</label>
                <argon-input type="text" v-model="form.low" />
              </div>

              <div class="col-md-4">
                <label for="example-text-input" class="form-control-label">Cant media</label>
                <argon-input type="text" v-model="form.medium" />
              </div>

              <div class="col-md-4">
                <label for="example-text-input" class="form-control-label">Cant alta</label>
                <argon-input type="text" v-model="form.high" />
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Bodega</label>
                <select name="" id="" class="form-select" v-model="form.bodega_id">
                  <option value="">Seleccionar</option>
                  <option v-for="bodega in bodegas" :key="bodega.id" :value="bodega.id">
                    {{ bodega.name }}
                  </option>
                </select>
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Estado</label>
                <select name="" id="" class="form-select" v-model="form.status">
                  <option value="0">Inactivo</option>
                  <option value="1">Activo</option>
                </select>
              </div>

            </div>
          </div>
        </div>

      </div>

      <!-- Tabla de variantes del producto -->
      <div class="col-12" v-if="form.id != 0 && form.shopify_details && form.shopify_details.variants && form.shopify_details.variants.length > 0">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <h6>Variantes del Producto (Shopify)</h6>
            </div>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Título
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      SKU
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Precio
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Gramos
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      ID Shopify
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Código de barras
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(variant, index) in form.shopify_details.variants" :key="index">
                    <td class="align-middle text-sm">
                      {{ variant.title || '-' }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ variant.sku || '-' }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ variant.price ? Number(variant.price).toLocaleString('es-ES', { minimumFractionDigits: 0 }) : '-' }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ variant.grams || '-' }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ variant.id || '-' }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      <div class="input-group input-group-sm">
                        <input type="text" class="form-control form-control-sm" v-model="variant.barcode" placeholder="Código de barras" />
                        <button
                          type="button"
                          class="btn btn-outline-secondary mb-0"
                          title="Imprimir código de barras"
                          @click="openPrintModal(variant.barcode, form.name + (variant.title && variant.title !== 'Default Title' ? ' - ' + variant.title : ''), variant.price || form.sale_price)"
                          style="border-right: 1px solid #000000 !important;border-left: 1px solid #000000 !important;"
                        >
                          <i class="fas fa-barcode"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Stock por variantes (talla y color) -->
      <div class="col-8" v-if="form.id != 0">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center justify-content-between">
              <h6 class="mb-0">Stock por Talla / Color</h6>
              <div class="d-flex gap-2">
                <button
                  type="button"
                  class="btn btn-info btn-sm"
                  @click="printAllVariantLabels"
                  :disabled="printingAllLabels || variantRows.length === 0"
                  title="Generar etiquetas de todas las variantes con stock"
                >
                  <i class="fas" :class="printingAllLabels ? 'fa-spinner fa-spin' : 'fa-print'"></i>
                  Generar etiquetas globales
                </button>
                <button type="button" class="btn btn-primary btn-sm" @click="openBulkVariantModal">
                  <i class="fas fa-plus"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div v-if="variantRows.length === 0" class="text-center text-secondary text-sm py-3">
              No hay variantes configuradas.<br>
              El stock total se maneja con el campo "Stock" de arriba.
            </div>
            <div v-else>
              <div v-for="vr in sortedVariantRows" :key="vr.originalIdx" class="variant-row">
                <div class="input-group input-group-sm" style="flex: 2;">
                  <input type="text" class="form-control form-control-sm" v-model="variantRows[vr.originalIdx].barcode" placeholder="Código de barras" />
                  
                  <button
                    type="button"
                    class="btn btn-outline-secondary btn-sm mb-0"
                    title="Imprimir código de barras"
                    @click="openVariantPrintModal(vr.originalIdx)"
                    :disabled="!vr.barcode"
                    style="border-right: 1px solid #000000 !important;"
                  >
                    <i class="fas fa-barcode"></i>
                  </button>
                </div>
                <select class="form-select form-select-sm" v-model="variantRows[vr.originalIdx].size_id" style="flex: 1;">
                  <option :value="null">Talla</option>
                  <option v-for="s in sizesList" :key="s.id" :value="s.id">{{ s.size }}</option>
                </select>
                <select class="form-select form-select-sm" v-model="variantRows[vr.originalIdx].color_id" style="flex: 1;">
                  <option :value="null">Color</option>
                  <option v-for="c in colorsList" :key="c.id" :value="c.id">{{ c.name }}</option>
                </select>
                <input type="number" min="0" class="form-control form-control-sm" v-model.number="variantRows[vr.originalIdx].quantity" placeholder="Cant." style="flex: 1;" />
                <button type="button" class="btn btn-link btn-sm text-danger p-0 lh-1 d-flex align-items-center" @click="removeVariantRow(vr.originalIdx)" title="Eliminar">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
              <div class="mt-2 text-sm text-secondary">
                Total variantes: {{ variantTotal }}
              </div>
              <button type="button" class="btn btn-success btn-sm w-100 mt-2" @click="saveVariants" :disabled="savingVariants">
                <i class="fas" :class="savingVariants ? 'fa-spinner fa-spin' : 'fa-save'"></i>
                Guardar variantes
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- Modal agregar variantes en lote -->
    <div v-if="showBulkVariantModal" class="barcode-modal-overlay" @click.self="closeBulkVariantModal">
      <div class="barcode-modal card shadow" style="max-width: 500px;">
        <div class="card-body">
          <h6 class="mb-3">Agregar variantes en lote</h6>
          <p class="text-sm text-muted mb-3">Seleccione tallas y colores para generar todas las combinaciones posibles.</p>

          <div class="mb-3">
            <label class="form-control-label text-sm mb-1">Tallas</label>
            <select ref="bulkSizesSelect" multiple class="form-select" style="width:100%;">
              <option v-for="s in sizesList" :key="s.id" :value="s.id">{{ s.size }}</option>
            </select>
          </div>

          <div class="mb-3">
            <label class="form-control-label text-sm mb-1">Colores</label>
            <select ref="bulkColorsSelect" multiple class="form-select" style="width:100%;">
              <option v-for="c in colorsList" :key="c.id" :value="c.id">{{ c.name }}</option>
            </select>
          </div>

          <div class="d-flex gap-2 justify-content-end mt-3">
            <button type="button" class="btn btn-secondary btn-sm" @click="closeBulkVariantModal">Cancelar</button>
            <button type="button" class="btn btn-success btn-sm" @click="confirmBulkVariants">
              <i class="fas fa-check me-1"></i> Generar variantes
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de impresión de código de barras -->
    <div v-if="showPrintModal" class="barcode-modal-overlay" @click.self="closePrintModal">
      <div class="barcode-modal card shadow">
        <div class="card-body">
          <h6 class="mb-3">Imprimir código de barras</h6>

          <div v-if="!printData.barcode" class="alert alert-warning py-2 text-sm">
            Este producto no tiene un código de barras asignado.
          </div>

          <template v-else>
            <div class="mb-3">
              <label class="form-control-label">Cantidad de etiquetas a imprimir</label>
              <input type="number" min="1" class="form-control" v-model.number="printData.quantity" />
            </div>

            <p class="text-xs text-muted mb-2">Vista previa de la etiqueta (100 x 50 mm)</p>
            <div class="barcode-preview-wrapper">
              <div class="barcode-label" ref="labelPreview">
                <div class="barcode-label-header">
                  <span class="barcode-label-name">{{ printData.name || 'PRODUCTO' }}</span>
                </div>
                <div class="barcode-label-body">
                  <svg ref="previewSvg"></svg>
                </div>
                <div class="barcode-label-number">{{ printData.barcode }}</div>
              </div>
            </div>
          </template>

          <div class="d-flex gap-2 justify-content-end mt-3">
            <button type="button" class="btn btn-secondary btn-sm" @click="closePrintModal">Cancelar</button>
            <button
              v-if="printData.barcode"
              type="button"
              class="btn btn-success btn-sm"
              @click="printLabels"
            >
              <i class="fas fa-print me-1"></i> Imprimir
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
import ArgonInput from "../../../components/ArgonInput.vue";
import ArgonTextarea from "../../../components/ArgonTextarea.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import Swal from 'sweetalert2';
import JsBarcode from 'jsbarcode';
import 'select2/dist/css/select2.css';
import 'select2';
import $ from 'jquery';
import inventoryService from '@/services/inventory.service';

const body = document.getElementsByTagName("body")[0];

export default {
  name: "Models Create",
  data() {
    return {
      showMenu: false,
      isSaving: false,
      form: {
        id: 0,
        name: '',
        ref: '',
        description: '',
        category_id: null,
        barcode: '',
        quantity: 0,
        status: 1,
        bodega_id: null,
        price: 0,
        sale_price: 1,
        manage_stock: true,
        low: 100,
        medium: 200,
        high: 300,
      },
      bodegas: [],
      categoriesList: [],
      showPrintModal: false,
      printData: {
        barcode: '',
        name: '',
        price: 0,
        quantity: 3,
      },
      sizesList: [],
      colorsList: [],
      variantRows: [],
      savingVariants: false,
      printingAllLabels: false,
      showBulkVariantModal: false,
      bulkSelectedSizes: [],
      bulkSelectedColors: [],
    };
  },
  components: { ArgonInput, ArgonTextarea, ArgonButton },
  computed: {
    variantTotal() {
      return this.variantRows.reduce((sum, v) => sum + (Number(v.quantity) || 0), 0);
    },
    sortedVariantRows() {
      return [...this.variantRows].map((vr, originalIdx) => ({ ...vr, originalIdx })).sort((a, b) => {
        const sizeA = this.sizesList.find(s => s.id === a.size_id);
        const sizeB = this.sizesList.find(s => s.id === b.size_id);
        const nameA = sizeA ? sizeA.size : '';
        const nameB = sizeB ? sizeB.size : '';
        if (nameA !== nameB) return nameA.localeCompare(nameB, undefined, { numeric: true });
        const colorA = this.colorsList.find(c => c.id === a.color_id);
        const colorB = this.colorsList.find(c => c.id === b.color_id);
        const cNameA = colorA ? colorA.name : '';
        const cNameB = colorB ? colorB.name : '';
        return cNameA.localeCompare(cNameB);
      });
    },
  },
  methods: {
    formatPrice(value) {
      const num = Number(value) || 0;
      return '$' + num.toLocaleString('es-CO', { minimumFractionDigits: 0 });
    },
    openPrintModal(barcode, name, price) {
      this.printData = {
        barcode: barcode ? String(barcode).trim() : '',
        name: (name || '').toUpperCase(),
        price: price || 0,
        quantity: 3,
      };
      this.showPrintModal = true;
      if (this.printData.barcode) {
        this.$nextTick(() => this.renderPreviewBarcode());
      }
    },
    closePrintModal() {
      this.showPrintModal = false;
    },
    renderPreviewBarcode() {
      if (!this.$refs.previewSvg) return;
      try {
        JsBarcode(this.$refs.previewSvg, this.printData.barcode, {
          format: 'CODE128',
          displayValue: true,
          fontSize: 12,
          height: 50,
          margin: 0,
          width: 1,
        });
      } catch (e) {
        console.error('Error generando código de barras:', e);
      }
    },
    printLabels() {
      const qty = Math.max(1, parseInt(this.printData.quantity) || 1);

      // Generar SVG del código de barras
      const tmpSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      try {
        JsBarcode(tmpSvg, this.printData.barcode, {
          format: 'CODE128',
          displayValue: false,
          fontSize: 12,
          height: 50,
          margin: 0,
          width: 2,
        });
      } catch (e) {
        Swal.fire('Error', 'No se pudo generar el código de barras.', 'error');
        return;
      }
      const barcodeSvg = new XMLSerializer().serializeToString(tmpSvg);

      const name = this.printData.name || 'PRODUCTO';

      const labelHtml = `
          <div class="label">
            <div class="label-header">
              <span class="label-name">${name}</span>
            </div>
            <div class="label-body">${barcodeSvg}</div>
            <div class="label-number">${this.printData.barcode}</div>
          </div>`;

      let rows = '';
      const total = qty;
      const remainder = total % 3;
      const padded = remainder > 0 ? total + (3 - remainder) : total;
      for (let i = 0; i < padded; i++) {
        if (i % 3 === 0) rows += '<div class="label-row">';
        if (i < total) {
          rows += labelHtml;
        } else {
          rows += '<div class="label label-empty"></div>';
        }
        if (i % 3 === 2 || i === padded - 1) rows += '</div>';
      }

      const html = `
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="utf-8" />
          <title>Imprimir códigos de barras</title>
          <style>
            @page { size: 104mm 25mm; margin: 0; }
            * { box-sizing: border-box; }
            html, body { margin: 0; padding: 0; }
            .label-row {
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              width: 104mm;
              height: 25mm;
              page-break-after: always;
            }
            .label {
              width: 34mm;
              height: 25mm;
              padding: 4mm;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              font-family: Arial, Helvetica, sans-serif;
              overflow: hidden;
            }
            .label-empty {
              visibility: hidden;
            }
            .label-header {
              display: flex;
              justify-content: space-between;
              align-items: flex-start;
              width: 100%;
            }
            .label-name {
              font-size: 7pt;
              font-weight: bold;
              word-break: break-word;
              line-height: 1.1;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .label-price {
              font-size: 7pt;
              font-weight: bold;
            }
            .label-body {
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100%;
            }
            .label-body svg {
              width: 100%;
              height: auto;
              min-height: 10mm;
              display: block;
            }
            .label-number {
              font-size: 7pt;
              font-weight: bold;
              text-align: center;
              width: 100%;
              letter-spacing: 0.5pt;
            }
          </style>
        </head>
        <body onload="window.onafterprint = function(){ window.close(); }; setTimeout(function(){ window.print(); }, 100);">
          ${rows}
        </body>
        </html>`;

      const printWindow = window.open('', '_blank', 'width=800,height=600');
      if (!printWindow) {
        Swal.fire('Bloqueado', 'Permita las ventanas emergentes para imprimir.', 'warning');
        return;
      }
      printWindow.document.open();
      printWindow.document.write(html);
      printWindow.document.close();

      this.closePrintModal();
    },
    printAllVariantLabels() {
      // Filtrar variantes con cantidad > 0 y barcode válido
      const variants = this.variantRows.filter(vr => {
        const qty = parseInt(vr.quantity) || 0;
        const bc = vr.barcode ? String(vr.barcode).trim() : '';
        return qty > 0 && bc;
      });

      if (variants.length === 0) {
        Swal.fire('Sin variantes', 'No hay variantes con stock y código de barras para generar etiquetas.', 'warning');
        return;
      }

      const totalLabels = variants.reduce((sum, v) => sum + (parseInt(v.quantity) || 0), 0);

      Swal.fire({
        title: 'Generar etiquetas globales',
        text: `Se generarán ${totalLabels} etiquetas de ${variants.length} variante(s).`,
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Imprimir',
        cancelButtonText: 'Cancelar',
      }).then(result => {
        if (!result.isConfirmed) return;

        this.printingAllLabels = true;

        // Generar los barcodes SVG de cada variante
        const labels = [];
        for (const vr of variants) {
          const qty = parseInt(vr.quantity) || 0;
          const bc = String(vr.barcode).trim();
          const sizeName = this.sizesList.find(s => s.id === vr.size_id)?.size || '';
          const colorName = this.colorsList.find(c => c.id === vr.color_id)?.name || '';
          const variantLabel = [sizeName, colorName].filter(Boolean).join(' ');
          const name = (this.form.name || 'PRODUCTO') + (variantLabel ? ' - ' + variantLabel : '');

          const tmpSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          try {
            JsBarcode(tmpSvg, bc, {
              format: 'CODE128',
              displayValue: false,
              fontSize: 12,
              height: 50,
              margin: 0,
              width: 2,
            });
          } catch (e) {
            console.error('Error generando barcode para variante:', bc, e);
            continue;
          }
          const barcodeSvg = new XMLSerializer().serializeToString(tmpSvg);

          const labelHtml = `
              <div class="label">
                <div class="label-header">
                  <span class="label-name">${name}</span>
                </div>
                <div class="label-body">${barcodeSvg}</div>
                <div class="label-number">${bc}</div>
              </div>`;

          for (let i = 0; i < qty; i++) {
            labels.push(labelHtml);
          }
        }

        if (labels.length === 0) {
          Swal.fire('Error', 'No se pudieron generar las etiquetas.', 'error');
          this.printingAllLabels = false;
          return;
        }

        // Agrupar de a 3 por fila
        let rows = '';
        const total = labels.length;
        const remainder = total % 3;
        const padded = remainder > 0 ? total + (3 - remainder) : total;
        for (let i = 0; i < padded; i++) {
          if (i % 3 === 0) rows += '<div class="label-row">';
          if (i < total) {
            rows += labels[i];
          } else {
            rows += '<div class="label label-empty"></div>';
          }
          if (i % 3 === 2 || i === padded - 1) rows += '</div>';
        }

        const html = `
          <!DOCTYPE html>
          <html>
          <head>
            <meta charset="utf-8" />
            <title>Imprimir etiquetas globales</title>
            <style>
              @page { size: 104mm 25mm; margin: 0; }
              * { box-sizing: border-box; }
              html, body { margin: 0; padding: 0; }
              .label-row {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                width: 104mm;
                height: 25mm;
                page-break-after: always;
              }
              .label {
                width: 34mm;
                height: 25mm;
                padding: 4mm;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                font-family: Arial, Helvetica, sans-serif;
                overflow: hidden;
              }
              .label-empty { visibility: hidden; }
              .label-header {
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                width: 100%;
              }
              .label-name {
                font-size: 8pt;
                font-weight: bold;
                word-break: break-word;
                line-height: 1.1;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .label-body {
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
              }
              .label-body svg {
                width: 100%;
                height: auto;
                max-height: 7mm;
                display: block;
              }
              .label-number {
                font-size: 8pt;
                font-weight: bold;
                text-align: center;
                width: 100%;
                letter-spacing: 0.5pt;
              }
            </style>
          </head>
          <body onload="window.onafterprint = function(){ window.close(); }; setTimeout(function(){ window.print(); }, 100);">
            ${rows}
          </body>
          </html>`;

        const printWindow = window.open('', '_blank', 'width=800,height=600');
        if (!printWindow) {
          Swal.fire('Bloqueado', 'Permita las ventanas emergentes para imprimir.', 'warning');
          this.printingAllLabels = false;
          return;
        }
        printWindow.document.open();
        printWindow.document.write(html);
        printWindow.document.close();

        this.printingAllLabels = false;
      });
    },
    normalizeBoolean(value) {
      if (value === undefined || value === null) {
        return true;
      }
      if (typeof value === 'string') {
        return value === '1' || value.toLowerCase() === 'true';
      }
      return value === 1 || value === true;
    },
    async loadInventoryData(id) {
      try {
        const res = await inventoryService.getData(id);
        if (res.data) {
          const data = res.data.data || res.data;
          this.form = {
            ...this.form,
            ...data,
            manage_stock: this.normalizeBoolean(data.manage_stock),
          };
          this.$nextTick(() => {
            this.initCategorySelect2();
          });
          this.loadVariants();
        }
      } catch (error) {
        console.error('Error al cargar los datos del inventario:', error);
        Swal.fire('Error', 'No se pudieron cargar los datos del producto', 'error');
      }
    },
    async getBodegas() {
      this.bodegas = await this.$store.dispatch('bodegas/getAll');
      if (this.bodegas && this.bodegas.length > 0 && !this.form.bodega_id) {
        this.form.bodega_id = this.bodegas[0].id;
      }
    },
    async loadCategories() {
      try {
        const res = await this.$store.dispatch('categories/getCategories');
        this.categoriesList = res?.data || [];
      } catch (e) {
        console.error('Error loading categories:', e);
        this.categoriesList = [];
      }
    },
    initCategorySelect2() {
      const $sel = $(this.$refs.categorySelect);
      $sel.select2({
        placeholder: 'Seleccionar categoría',
        width: '100%',
        allowClear: true,
      }).on('change', () => {
        const val = $sel.val();
        this.form.category_id = val ? Number(val) : null;
      });
      // Setear valor actual
      $sel.val(this.form.category_id || '').trigger('change');
    },
    async loadSizesAndColors() {
      try {
        const [sizesRes, colorsRes] = await Promise.all([
          this.$store.dispatch('tallas/getAll'),
          this.$store.dispatch('colors/getColors'),
        ]);
        this.sizesList = sizesRes || [];
        this.colorsList = colorsRes?.data || [];
      } catch (e) {
        console.error('Error loading sizes/colors:', e);
      }
    },
    async loadVariants() {
      if (this.form.id === 0) return;
      try {
        const res = await inventoryService.getVariants(this.form.id);
        this.variantRows = (res.data || []).map(v => ({
          id: v.id,
          size_id: v.size_id,
          color_id: v.color_id,
          quantity: v.quantity,
          barcode: v.barcode || '',
        }));
      } catch (e) {
        console.error('Error loading variants:', e);
      }
    },
    addVariantRow() {
      const barcode = String(Math.floor(10000000 + Math.random() * 90000000));
      this.variantRows.push({ size_id: null, color_id: null, quantity: 0, barcode });
    },
    openBulkVariantModal() {
      this.showBulkVariantModal = true;
      this.$nextTick(() => {
        const $sizes = $(this.$refs.bulkSizesSelect);
        const $colors = $(this.$refs.bulkColorsSelect);

        $sizes.select2({
          placeholder: 'Seleccionar tallas',
          width: '100%',
          closeOnSelect: false,
        }).on('change', () => {
          this.bulkSelectedSizes = $sizes.val() || [];
        });

        $colors.select2({
          placeholder: 'Seleccionar colores',
          width: '100%',
          closeOnSelect: false,
        }).on('change', () => {
          this.bulkSelectedColors = $colors.val() || [];
        });
      });
    },
    closeBulkVariantModal() {
      this.showBulkVariantModal = false;
      this.bulkSelectedSizes = [];
      this.bulkSelectedColors = [];
      this.$nextTick(() => {
        if (this.$refs.bulkSizesSelect) $(this.$refs.bulkSizesSelect).val(null).trigger('change');
        if (this.$refs.bulkColorsSelect) $(this.$refs.bulkColorsSelect).val(null).trigger('change');
      });
    },
    confirmBulkVariants() {
      const sizeIds = this.bulkSelectedSizes.map(Number);
      const colorIds = this.bulkSelectedColors.map(Number);

      if (sizeIds.length === 0 && colorIds.length === 0) {
        Swal.fire('Atención', 'Seleccione al menos una talla o un color.', 'warning');
        return;
      }

      const finalSizeIds = sizeIds.length > 0 ? sizeIds : [null];
      const finalColorIds = colorIds.length > 0 ? colorIds : [null];

      finalSizeIds.forEach(sid => {
        finalColorIds.forEach(cid => {
          const exists = this.variantRows.some(vr => vr.size_id === sid && vr.color_id === cid);
          if (!exists) {
            const barcode = String(Math.floor(10000000 + Math.random() * 90000000));
            this.variantRows.push({ size_id: sid, color_id: cid, quantity: 0, barcode });
          }
        });
      });

      this.closeBulkVariantModal();
    },
    generateVariantBarcode(idx) {
      this.variantRows[idx].barcode = String(Math.floor(10000000 + Math.random() * 90000000));
    },
    generateProductBarcode() {
      this.form.barcode = String(Math.floor(10000000 + Math.random() * 90000000));
    },
    openVariantPrintModal(idx) {
      const vr = this.variantRows[idx];
      const sizeName = this.sizesList.find(s => s.id === vr.size_id)?.size || '';
      const colorName = this.colorsList.find(c => c.id === vr.color_id)?.name || ''
      const parts = [this.form.name];
      if (sizeName) parts.push(sizeName);
      if (colorName) parts.push(colorName);
      const name = parts.join(' - ');
      this.openPrintModal(vr.barcode, name, this.form.sale_price);
    },
    async removeVariantRow(idx) {
      const vr = this.variantRows[idx];
      if (!vr) return;

      // Si la variante ya existe en BD (tiene id), verificar si esta en uso
      if (vr.id) {
        try {
          const checkRes = await inventoryService.checkVariantUsage(vr.id);
          if (checkRes.data.in_use) {
            const sizeName = this.sizesList.find(s => s.id === vr.size_id)?.size || '';
            const colorName = this.colorsList.find(c => c.id === vr.color_id)?.name || '';
            const label = [sizeName, colorName].filter(Boolean).join(' ') || `Variante #${vr.id}`;
            await Swal.fire({
              title: 'No se puede eliminar',
              html: `La variante <strong>${label}</strong> esta asociada a <strong>${checkRes.data.count}</strong> pedido(s) y no puede ser eliminada.`,
              icon: 'error',
              confirmButtonText: 'Entendido',
              confirmButtonColor: '#d33',
            });
            return;
          }
        } catch (e) {
          console.error('Error al verificar uso de variante:', e);
        }
      }

      const result = await Swal.fire({
        title: '¿Eliminar variante?',
        text: '¿Estás seguro de que deseas eliminar esta variante?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#d33',
      });
      if (result.isConfirmed) {
        this.variantRows.splice(idx, 1);
      }
    },
    async saveVariants() {
      this.savingVariants = true;
      try {
        await inventoryService.saveVariants(this.form.id, this.variantRows);
        await Swal.fire('Éxito', 'Variantes guardadas correctamente', 'success');
        await this.loadVariants();
        const invRes = await inventoryService.getData(this.form.id);
        if (invRes.data) {
          this.form.quantity = invRes.data.quantity;
        }
      } catch (e) {
        console.error('Error saving variants:', e);
        const msg = e.response?.data?.message || 'No se pudieron guardar las variantes';
        await Swal.fire('Error', msg, 'error');
      } finally {
        this.savingVariants = false;
      }
    },
    async save() {
      // Evitar doble guardado
      if (this.isSaving) {
        return;
      }

      try {
        // Activar estado de guardado
        this.isSaving = true;

        // Mostrar modal de carga
        Swal.fire({
          title: 'Guardando...',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("inventory/save", this.form);
        
        // Cerrar modal de carga
        Swal.close();

        if (response && response.status >= 200 && response.status < 300) {
          // Actualizar el formulario con los datos guardados
          const createdId = response.data?.data?.id || response.data?.id;
          if (createdId) {
            this.form.id = createdId;
          }
          
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El insumo ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          });

          // Redirigir a la edición del producto recién creado para agregar variantes
          this.$router.push({
            name: 'Inventory Edit',
            params: { id: this.form.id },
          });

        } else {
          throw new Error(response.data.message || 'Error al guardar el proyecto');
        }

      } catch (error) {
        // Cerrar modal de carga en caso de error
        Swal.close();
        console.error("Error al crear el proyecto:", error);
        const errData = error?.data || error?.response?.data;
        const msg = errData?.errors?.ref?.[0] || errData?.message || error?.message || 'Error al guardar el proyecto';
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: msg,
        });
      } finally {
        // Desactivar estado de guardado
        this.isSaving = false;
      }
    },
  },
  async mounted() {
    this.getBodegas();
    this.loadSizesAndColors();
    await this.loadCategories();

    const editId = this.$route.params.id;

    if (editId) {
      this.loadInventoryData(editId);
    } else {
      this.$nextTick(() => {
        this.initCategorySelect2();
      });
    }

    if (this.form.id === 0 && !this.form.barcode) {
      this.form.barcode = String(Math.floor(100000000 + Math.random() * 900000000));
    }

    this.$store.state.isAbsolute = false;
    setNavPills();
    setTooltip();
  },
  beforeMount() {
    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>

<style>
.disabled-link {
  color: gray;
  pointer-events: none;
  /* Impide la interacción */
  cursor: not-allowed;
  /* Cambia el cursor para indicar que está deshabilitado */
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.page-item {
  margin: 0 5px;
}

.active {
  font-weight: bold;
  /* Estilo para la página activa */
}

/* Modal de impresión de código de barras */
.barcode-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1080;
}
.barcode-modal {
  width: 100%;
  max-width: 480px;
  margin: 1rem;
}
.select2-container--open {
  z-index: 9999;
}
.select2-dropdown {
  z-index: 9999;
}
.barcode-preview-wrapper {
  display: flex;
  justify-content: center;
  background: #f6f7f9;
  border: 1px dashed #ccc;
  border-radius: 6px;
  padding: 10px;
}
.barcode-label {
  width: 100mm;
  height: 50mm;
  max-width: 100%;
  background: #fff;
  border: 1px solid #ddd;
  padding: 4mm;
  display: flex;
  flex-direction: column;
  transform-origin: top center;
}
.barcode-label-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}
.barcode-label-name {
  font-size: 12pt;
  font-weight: bold;
  max-width: 60mm;
  word-break: break-word;
}
.barcode-label-price {
  font-size: 14pt;
  font-weight: bold;
}
.barcode-label-body {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.barcode-label-body svg {
  max-width: 90mm;
  max-height: 25mm;
}
.barcode-label-number {
  font-size: 10pt;
  font-weight: bold;
  text-align: center;
  width: 100%;
  letter-spacing: 1pt;
}

.variant-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
}
.variant-row select,
.variant-row input {
  margin-bottom: 0;
}
.variant-row .btn-link {
  margin: 0;
  padding: 0;
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}
</style>
